import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessagesCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 7.19805L8.7898 8.5L11 5.99805M19.2 9.29934C19.6774 9.29934 20.1352 9.48902 20.4728 9.82665C20.8104 10.1643 21 10.6222 21 11.0997V20.359C21 20.4854 20.9625 20.6089 20.8923 20.714C20.8221 20.8191 20.7223 20.901 20.6055 20.9494C20.4888 20.9978 20.3603 21.0104 20.2364 20.9858C20.1124 20.9611 19.9986 20.9003 19.9092 20.8109L17.9274 18.8287C17.5899 18.491 17.1322 18.3013 16.6548 18.3012H10.2C9.72261 18.3012 9.26477 18.1115 8.92721 17.7739C8.58964 17.4362 8.4 16.9783 8.4 16.5008V15.6006M15.6 10.1995C15.6 10.677 15.4104 11.1349 15.0728 11.4726C14.7352 11.8102 14.2774 11.9999 13.8 11.9999H7.3452C6.86785 12 6.41009 12.1897 6.0726 12.5274L4.0908 14.5096C4.00143 14.599 3.88758 14.6598 3.76364 14.6845C3.6397 14.7091 3.51123 14.6965 3.39448 14.6481C3.27772 14.5997 3.17793 14.5178 3.10772 14.4127C3.0375 14.3077 3.00002 14.1841 3 14.0577V4.79842C3 4.32093 3.18964 3.863 3.52721 3.52536C3.86477 3.18773 4.32261 2.99805 4.8 2.99805H13.8C14.2774 2.99805 14.7352 3.18773 15.0728 3.52536C15.4104 3.863 15.6 4.32093 15.6 4.79842V10.1995Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgMessagesCheck);
export { ForwardRef as ReactComponent };
